<template>
  <div class="cps">
    <!-- @click="openQQ" -->
    <!-- <img style="cursor: pointer; width: 100%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/fourth_year.png" alt="" /> -->
    <!-- <img style="cursor: pointer; width: 100%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home-banner10.png" alt="" /> -->
    <!-- <div class="content-center">
      <img style="cursor: pointer; width: 60%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home-banner10.png" alt="" />
    </div> -->

    <div>
      <div class="content-center" style="font-weight: bold; font-size: 30px; padding: 20px">新客活动数据预览</div>

      <div class="content-center">
        <div>
          <div class="content-center" style="font-weight: bold; font-size: 20px; padding: 10px">首单赠一<span style="font-weight: 400; font-size: 14px; margin-left: 10px">(第一重优惠)</span></div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="productCode" label="产品" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.productCode == 'CPS'">上海舱单</div>
                <div v-else-if="scope.row.productCode == 'CCAM_QINGDAO'">青岛舱单</div>
                <div v-else-if="scope.row.productCode == 'TRACK_SHANGHAI'">箱货跟踪</div>
                <div v-else>{{ scope.row.productCode }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="ladder1difference" label="剩余单量" width="80" />
            <el-table-column prop="ladder1gift" label="首单赠一" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.ladder1gift == 1" style="color: green">已达成</div>
                <div v-else style="color: red">未达成</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin: 0 20px">
          <div class="content-center" style="font-weight: bold; font-size: 20px; padding: 10px">第四单赠一<span style="font-weight: 400; font-size: 14px; margin-left: 10px">(第二重优惠)</span></div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="productCode" label="产品" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.productCode == 'CPS'">上海舱单</div>
                <div v-else-if="scope.row.productCode == 'CCAM_QINGDAO'">青岛舱单</div>
                <div v-else-if="scope.row.productCode == 'TRACK_SHANGHAI'">箱货跟踪</div>
                <div v-else>{{ scope.row.productCode }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="ladder2difference" label="剩余单量" width="80" />
            <el-table-column prop="ladder2gift" label="第四单赠一" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.ladder2gift == 1" style="color: green">已达成</div>
                <div v-else style="color: red">未达成</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <div class="content-center" style="font-weight: bold; font-size: 20px; padding: 10px">满赠活动<span style="font-weight: 400; font-size: 14px; margin-left: 10px">(第三重优惠：国内舱单发15单赠1单,海外舱单发3单赠1单)</span></div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="productCode" label="产品" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.productCode == 'CPS'">上海舱单</div>
                <div v-else-if="scope.row.productCode == 'CCAM_QINGDAO'">青岛舱单</div>
                <div v-else-if="scope.row.productCode == 'TRACK_SHANGHAI'">箱货跟踪</div>
                <div v-else>{{ scope.row.productCode }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="ladder3difference" label="满赠剩余单量" width="110">
              <template slot-scope="scope">
                <div v-if="scope.row.productCode == 'EM' || scope.row.productCode == 'ACI' || scope.row.productCode == 'AFR' || scope.row.productCode == 'AMS' || scope.row.productCode == 'ISF'">{{ scope.row.ladder3difference }}</div>
                <div v-else>{{ scope.row.ladder3difference }}</div>
                <!-- <div v-else style="color: red;">未达成</div> -->
              </template>
            </el-table-column>
            <el-table-column prop="ladder3difference" label="规则">
              <template slot-scope="scope">
                <div v-if="scope.row.productCode == 'EM' || scope.row.productCode == 'ACI' || scope.row.productCode == 'AFR' || scope.row.productCode == 'AMS' || scope.row.productCode == 'ISF'">第5单起每发3单赠1单</span></div>
                <div v-else-if="scope.row.productCode == 'VGM'"><span>第5箱起每发15箱赠1箱</span></div>
                <div v-else-if="scope.row.productCode == 'TRACK_SHANGHAI'"><span>第5票起每订阅15票赠1票</span></div>
                <div v-else><span>第5单起每发15单赠1单</span></div>
                <!-- <div v-else style="color: red;">未达成</div> -->
              </template>
            </el-table-column>
            <el-table-column prop="ladder3gift" label="获得单量" width="90" />
            <!-- <el-table-column prop="ladder3gift" label="合计赠送单量" width="120">
              <template slot-scope="scope">
                {{ scope.row.ladder1gift + scope.row.ladder2gift + scope.row.ladder3gift }}
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <div style="margin-left: 20px">
          <div class="content-center" style="font-weight: bold; font-size: 20px; padding: 10px; color: rgb(255, 112, 29)">活动总收益</div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="productCode" label="产品" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.productCode == 'CPS'">上海舱单</div>
                <div v-else-if="scope.row.productCode == 'CCAM_QINGDAO'">青岛舱单</div>
                <div v-else-if="scope.row.productCode == 'TRACK_SHANGHAI'">箱货跟踪</div>
                <div v-else>{{ scope.row.productCode }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="totalCnt" label="活动期间总单量" width="130" />
            <el-table-column prop="ladder3gift" label="合计获得单量" width="120">
              <template slot-scope="scope">
                {{ scope.row.ladder1gift + scope.row.ladder2gift + scope.row.ladder3gift }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div>
        <div style="display: flex;margin-top: 20px;">
        <div style="border: 1px solid #EBEEF5;padding: 20px;margin-right: 20px;width: 60%;">
          <div style="font-weight: bold;font-size: 24px;padding: 20px 0;">活动规则</div>
          <div class="text-div">1. 此优惠不与其他优惠同享</div>
          <div class="text-div">2. 国内舱单：上海舱单，青岛舱单，VGM，箱货跟踪</div>
          <div class="text-div">3. 海外舱单：AMS，ISF，AFR，EM，ACI</div>
          <div class="text-div">4. 有效订单：支付金额大于0的订单，删单，退款，柜面删单，青岛释放单等不计算 </div>
          <div class="text-div">5. 订单数量的计数规则：活动有效期内的订单数量为准，9款产品独立计算</div>
          <div class="text-div">6. 新客户范围：注册时间在2024年4月26日 - 2024年5月31日内注册的用户</div>
          <div class="text-div">7. 活动解释权以未斯科技为准</div>
        </div>
        <div  style="border: 1px solid #EBEEF5;padding: 20px;width: 40%;">
            <div>
              <div style="font-weight: bold; font-size: 24px; padding: 20px 0">奖励发放</div>
              <div class="text-div">1. 核对日期：2024年6月1日 - 2024年6月4日</div>
              <div class="text-div">2. 发放日期：2024年6月5日 - 2024年6月6日</div>
              <div class="text-div">3. 活动时间：2024年4月26日 - 2024年5月31日</div>
              <div class="text-div">4. 新客活动：新客活动仅新客能参加</div>
              <div class="text-div">5. 充赠活动：新客老客都可参加<el-button type="primary" size="mini" @click="toUserPay">前往充赠页面</el-button></div>
            </div>
            <!-- <div style="padding: 0 20px;">
            <div class="content-center" style="font-weight: bold;font-size: 24px;padding: 20px;">活动时间</div>
            <div class="content-center">2024.04.26 - 2024.05.31</div>
          </div>
          <div>
            <div class="content-center" style="font-weight: bold;font-size: 24px;padding: 20px;">活动对象</div>
            <div class="content-center">新用户</div>
            <div class="content-center">老用户（优惠不叠加）</div>
          </div> -->
          </div>
        </div>
      </div>
      <!-- <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="productCode" label="产品" width="180" />
        <el-table-column prop="totalCnt" label="活动期间总单量" width="180" />
        <el-table-column prop="ladder1difference" label="发首单赠1单差值单量" width="180" />
        <el-table-column prop="ladder1gift" label="首单赠一" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.ladder1gift == 1" style="color: green;">已达成</div>
            <div v-else style="color: red;">未达成</div>
          </template>
        </el-table-column>
        <el-table-column prop="ladder2difference" label="发第4单赠1单差值单量" width="180" />
        <el-table-column prop="ladder2gift" label="第四单赠一" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.ladder2gift == 1" style="color: green;">已达成</div>
            <div v-else style="color: red;">未达成</div>
          </template>
        </el-table-column>
        <el-table-column prop="ladder3difference" label="满赠剩余单量（国内15赠1，海外3赠1）" />
        <el-table-column prop="ladder3gift" label="满赠活动获得单量" width="180" />
        <el-table-column prop="ladder3gift" label="合计赠送单量" width="180">
          <template slot-scope="scope">
            {{ scope.row.ladder1gift + scope.row.ladder2gift + scope.row.ladder3gift }}
          </template>
        </el-table-column>
      </el-table> -->
    </div>

    <!-- <div class="content-center" style="font-weight: bold;font-size: 30px;padding: 20px;">新客活动规则</div> -->
    <div>
      <!-- <div></div> -->
    </div>
    <div class="content-center" style="margin-top: 20px">
      <!-- <img style="cursor: pointer; width: 80%" src="./xinren.png" alt="" /> -->
      <!-- <img style="cursor: pointer; width: 80%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home-banner10.png" alt="" /> -->
    </div>
  </div>
</template>

<script>
import { openQQ } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'
import { activityOrderStatistic, burialPoint } from '@/api/user'
import router from '@/router'

export default {
  name: 'cps',
  data() {
    return {
      numUrl: `${ossUrl}/common/introduce/number-1.png`,
      tableData: []
    }
  },
  created() {
    this.getActivity()
  },
  methods: {
    openQQ,
    toUserPay(){
      burialPoint('/new/btn')
      router.push('/user/finance/balance')
    },
    getActivity() {
      activityOrderStatistic().then(res => {
        this.tableData = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cps {
  display: flex;
  align-items: center;
  justify-content: center;

  // 居中
  .content-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text-div {
    margin-bottom: 5px;
  }
}
</style>
